module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c553f53a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/CommentEvent.vue
// module id = 1468
// module chunks = 1